export const selectorConstants = {

    PRODUCT_SELECTOR_DEFAULT_TEXT: 'Select a Product',
    GEOGRAPHY_SELECTOR_DEFAULT_TEXT: 'Select a Geography',
    DATASET_SELECTOR_DEFAULT_TEXT: 'Select a Dataset',
    SIZES_DATASET : 'Sizes',
    EXPAND_ALL_TREE_NODES_EVENT: 'expandAllTreeNodesEvent',
    DUPLICATE_MULTIPLE_GEOGRAPHY_TEXT:'Multiple Selections',
    ADDITIONAL_SCROLL_HEIGHT: 2000,
    FETCH_NODES_COUNT: 10,
    NODES_OFFSET_VALUE: 0
};

export const PRODUCT_SELECTOR_CONSTANT = {
    SELECT_A_PRODUCT_LABEL: 'Select a Product',
    MULTIPLE_SELECTIONS: 'Multiple Selections',
};

export const SELECTOR_COMMON_CONSTANTS = {
    treeNodesFetchCount: 10,
    scrollDownHeight: 3000,
    timeOutMilliSeconds: 500,
    numberHundred: 100,
    numberFifty: 50,
    reliabilityYearTimeSeriesId: 535
};